<div class="loader">
  <svg viewBox="0 0 30 30" class="svg-preloader-sm">
    <symbol id="s-circle-sm">
      <circle r="5" cx="5" cy="5"></circle>
    </symbol>
    <rect class="r-bounds-sm" width="100%" height="100%"></rect>
    <g id="circle-sm" class="g-circles-sm">
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
    </g>
  </svg>
</div>
